import { render, staticRenderFns } from "./ImageBig.vue?vue&type=template&id=f853caaa&"
import script from "./ImageBig.vue?vue&type=script&lang=js&"
export * from "./ImageBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports